import { Trans, useTranslation } from 'react-i18next';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Shop } from '~/lib/types/tracking-types';
import { P2GBox, P2GGrid, P2GReactMap, P2GText, useP2GMediaQueryDown, useTheme } from '@parcel2go/core-ui';
import { useTenant } from '@parcel2go/npm-p2g-app';
import { TranslationNamespaces } from '~/lib/constants';
import { PublicSettings } from '~/lib/ui-serverless-settings';

const useStyles = makeStyles()(() => ({
  map: {
    height: '400px',
    width: '100%'
  }
}));

interface ITrackingWindowProps {
  shop: Shop;
}

const DeliveryShop: React.FC<ITrackingWindowProps> = (props) => {
  const theme = useTheme();
  const { settings } = useTenant();
  const { t } = useTranslation(TranslationNamespaces.TRACKING);
  const { classes } = useStyles();
  const isBreak = useP2GMediaQueryDown('sm');

  return (
    <P2GGrid container direction="column" spacing={4}>
      <P2GGrid item>
        <P2GText variant="h5" component="h5">
          <Trans
            t={t}
            i18nKey="RESULT_DELIVERY_SHOP_TITLE"
            defaults="The courier delivered your parcel to a local shop"
          />
        </P2GText>
        <P2GText>
          <Trans t={t} i18nKey="RESULT_DELIVERY_SHOP_DESCRIPTION" defaults="Your parcel is ready for collection from" />
        </P2GText>
      </P2GGrid>
      <P2GGrid item>
        <P2GGrid container direction={isBreak ? 'column' : 'row'} spacing={isBreak ? 2 : 8}>
          <P2GGrid item>
            <P2GGrid container direction="column" spacing={1}>
              <P2GGrid item>
                <P2GText>{props.shop.name}</P2GText>
              </P2GGrid>
              <P2GGrid item>
                <P2GText>{props.shop.address1}</P2GText>
              </P2GGrid>
              <P2GGrid item>
                <P2GText>{props.shop.address2}</P2GText>
              </P2GGrid>
              <P2GGrid item>
                <P2GText>{props.shop.postcode}</P2GText>
              </P2GGrid>
            </P2GGrid>
          </P2GGrid>
          {props.shop.latitude && props.shop.longitude && (
            <P2GGrid item flexGrow={2}>
              <P2GBox classNames={[classes.map]}>
                <P2GReactMap
                  markers={[
                    {
                      position: { lng: props.shop.longitude, lat: props.shop.latitude },
                      color: theme.palette.primary.main
                    }
                  ]}
                  apiKey={settings[PublicSettings.MAPSKEY] ?? ''}
                  center={{ lng: props.shop.longitude, lat: props.shop.latitude }}
                  zoom={15}
                ></P2GReactMap>
              </P2GBox>
            </P2GGrid>
          )}
        </P2GGrid>
      </P2GGrid>
    </P2GGrid>
  );
};

export default DeliveryShop;
